import { FilesUpdateData } from '@shared/types/input-file';
import { InputFileSearchValue } from '@shared/ui/input-file-search/types';

export const fileSearchToFileUpdateData = async (value: InputFileSearchValue): Promise<FilesUpdateData> => {
    return {
        addIds: value.addedUploadedFiles.map((file) => Number(file.id)),
        deleteIds: value.deletedUploadedFiles.map((file) => Number(file.id)),
        localFiles: value.localFiles.map((file) => file.file),
    };
};
